import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

//import RulesEngine from './screens/index.vue';
const RulesEngine = () => import('./screens/index.vue')

const rulesEngineRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.RULES_ENGINE_VIEW,
    PERMISSIONS_KEYS.RULES_ENGINE_INSERT,
    PERMISSIONS_KEYS.RULES_ENGINE_EDIT,
    PERMISSIONS_KEYS.RULES_ENGINE_DELETE,
  ])
) {
  // rulesEngineRoutes.push({
  //   path: '/ajuda/motor-de-regras',
  //   name: 'Motor de Regras|Ajuda',
  //   component: RulesEngineHelp,
  //   meta: {
  //     icon: 'fa-cog',
  //     requiresAuth: true,
  //   },
  // });

  rulesEngineRoutes.push({
    path: '/regras-da-prescricao/regras',
    name: 'Administração|Regra',
    component: RulesEngine,
    meta: {
      icon: 'fa-cog',
      requiresAuth: true,
    },
  });
}

export { rulesEngineRoutes };

